import { render, staticRenderFns } from "./NumInputVcDemo.vue?vue&type=template&id=945edcd6&scoped=true&"
import script from "./NumInputVcDemo.vue?vue&type=script&lang=js&"
export * from "./NumInputVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./NumInputVcDemo.vue?vue&type=style&index=0&id=945edcd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945edcd6",
  null
  
)

export default component.exports